// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e5d885ca","879":"f6e18059"}[chunkId] + ".chunk.js";
};